module.exports = __webpack_public_path__ + "static/img/pro3_tab4.8fd82ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab4.jpg
// module id = w7bW
// module chunks = 171